module.exports = __webpack_public_path__ + "img/job_examine07.d8da0c83.png";